import DesignerReport from '../DesignerReport';

const designerReport = new DesignerReport();
window.designerReport = designerReport;
export default designerReport;
